import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Hire iOS Developers for{" "}
              <span>Comprehensive Development Services</span>
            </h2>
            <p>
              At TekRevol, we create high-performance, feature-rich iOS
              applications using the latest technologies. Our iOS app developers
              combine creativity with technical expertise to ensure your app
              surpasses industry benchmarks. Explore our specialized iOS
              services:
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Augment Top iOS Developers
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>iOS App Development</h4>
                  <p>
                    Our iOS app developers excel in creating dynamic,
                    user-centric apps. Whether you need sleek consumer apps or
                    robust enterprise solutions, we deliver tailored services
                    that transform your concepts into high-performance iOS
                    experiences.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>App Design & User Interface (UI/UX)</h4>
                  <p>
                    Hiring iOS app developers from TekRevol means investing in
                    captivating design and seamless user experiences. Our UI/UX
                    experts craft engaging interfaces that keep users coming
                    back and enhance app's visual appeal and functionality.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>iOS App Maintenance & Support</h4>
                  <p>
                    Our commitment extends beyond the launch with comprehensive
                    maintenance and support services. Our top-grade iOS app
                    developers ensure your app remains robust, up-to-date, and
                    bug-free for consistent performance even long after
                    deployment.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Upgrade & Migration Services</h4>
                  <p>
                    Ensure the sustained relevance of your app by hiring our
                    skilled iOS developers. We specialize in seamless upgrades
                    and migrations. Align your app with the latest iOS versions
                    and industry standards to elevate its performance.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Quality Assurance & Testing</h4>
                  <p>
                    Our dedicated iOS app developers conduct rigorous testing to
                    ensure your app meets the highest standards. Count on us for
                    a seamless, error-free user experience that sets your iOS
                    application apart from the competition.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
